export default __webpack_public_path__ + "8933e126ff8a3f2d6024dec0e1f94dea.png";